
export const firstDayOfMonth = () => {
    let newDate = new Date();
    return new Date(newDate.getFullYear(), newDate.getMonth(), 1);
}
export const lastDayOfMonth = () => {
    let newDate = new Date();
    return new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
}
export const addOneDay = (date) => {
    let newDate = new Date(date)
    return new Date(newDate.setDate(newDate.getDate() + 1));
}